<script setup lang="ts">
import { computed } from 'vue'
import { faQuestion } from '@fortawesome/duotone-regular-svg-icons'
import { useIcons } from '~/composables/useIcons'

const props = defineProps<{
  icon?: string
  title: string
  color: string
}>()

const { duotone } = useIcons()

const isDark = computed(() => props.color !== 'white')

const colors = computed(() => isDark.value
  ? 'bg-(--theme-60) text-(--theme-pop)'
  : 'bg-(--theme-10) text-(--theme-60)'
)
</script>

<template>
  <div class="au-color-box not-prose flex gap-4 rounded-xl p-6" :class="colors">
    <div
      v-if="icon"
      class="grid flex-none text-lg"
    >
      <font-awesome-icon
        :icon="duotone.get(icon.slice(3)) || faQuestion"
        size="2x"
        :style="{
          '--fa-primary-color': isDark ? 'var(--theme-pop)' : 'var(--theme-60)',
          '--fa-secondary-color': isDark ? 'var(--theme-20)' : 'var(--theme-pop)',
          '--fa-secondary-opacity': '1',
        }"
      />
    </div>

    <div class="au-prose self-center">
      <slot />
    </div>
  </div>
</template>
